import { apiActions } from '../../../_core/api';
import { Middleware } from 'redux';
import { IStore } from '../../../store';
import ballastActions, {
	EBallastActions,
	EBallastConstants,
	TBallastActions,
} from '../actions';
import { jobActions } from '../../../_core/job';
import { IAuthActions } from '../../auth/actions';
import { TBallastTableLog, TTableBallastTank } from '../@types';
import moment from 'moment';
import { EMARPOLDocuments, EMARPOLModelName } from 'redux/app/marpol/@types';
import { commonUtils } from 'redux/_common';

const ballastTableLogsMiddleware: Middleware<{}, IStore> =
	({ dispatch, getState }) =>
		(next) =>
			(action: TBallastActions | IAuthActions) => {
				switch (action.type) {
					case EBallastActions.TABLE_LOGS_LOAD: {
						next(action);
						const { providedFilters: filters } = action.payload;
						const job = jobActions(EBallastConstants.FEATURE, action.type);
						let selectedBallastTankCode =
							getState().app.ballast.selectedBallastTankForTableLogs;

						if (selectedBallastTankCode === 'All Tanks') {
							selectedBallastTankCode = '';
						}

						dispatch(
							apiActions.apiRequest<TBallastTableLog[]>({
								feature: action.type,
								method: 'GET',
								url: `${commonUtils.getAPIBaseUrl()}${EBallastConstants.API_FOR_LOG}`,
								queryParams: {
									vesselId: filters.vesselId,
									marpolType: EMARPOLDocuments.BALLAST_WATER_RECORD,
									tankCode: encodeURIComponent(selectedBallastTankCode), // URL encode tank code because of spaces
									selectedDate: {
										$gte: moment(filters.startDate),
										$lte: moment(filters.endDate),
									},
									sortOrder: filters?.sortOrder ?? undefined,
								},
								preExecute() {
									dispatch(job.active({}));
								},
								postExecute: {
									onSuccess({ data }) {
										dispatch(
											ballastActions.document.tableLogsSet(data)
										);
										dispatch(
											job.success({
												notification: {
													timeout: 1500
												},
												message: 'Loaded ballast water record',
											})
										);
									},
									onError() {
										dispatch(job.error({}));
									},
									finally() {
										dispatch(job.idle({}));
									},
								},
							})
						);
						break;
					}
					case EBallastActions.BALLAST_TANKS: {
						next(action);
						const job = jobActions(EBallastConstants.FEATURE, action.type);
						const { vesselId, category } = action.payload;
						dispatch(
							apiActions.apiRequest<TTableBallastTank[]>({
								feature: action.type,
								method: 'GET',
								url: `${commonUtils.getAPIBaseUrl()}${EBallastConstants.API_FOR_TANKS}`,
								queryParams: {
									vesselId,
									category,
								},
								preExecute() {
									dispatch(job.active({}));
								},
								postExecute: {
									onSuccess({ data }) {
										dispatch(ballastActions.document.tankSpecificBallastTanks(data));
									},
									onError() {
										dispatch(job.error({}));
									},
									finally() {
										dispatch(job.idle({}));
									},
								},
							})
						);
						break;
					}
					default: {
						next(action);
						break;
					}
				}
			};
export default ballastTableLogsMiddleware;
